<template>
  <div class="file-processor">
    <span class="xl-loading__icon" v-if="isLoading" />
    <ViewerPic
      v-if="isShowImgComp" :id="fileId"
      @close="close" :preview-file-info="previewFileInfo"
    />
    <ViewerVideo
      v-else-if="isShowVideoComp" :id="fileId"
      @close="close" :preview-file-info="previewFileInfo"
    />
    <!-- <ViewerIframe
        v-else-if="isShowIframe" :fileType="fileExtension.replace(/\./g, '')"
        :src="iframeSrc"
        :name="resource.name"
        @close="close" @fail="onFail"
      />
      <TipDialog
        :visible="showNoSupport"
        title="不可预览提示"
        :desc="tipDesc"
        :okText="tipOkText"
        @ok="handleTipOk"
        @close="close"
      /> -->
  </div>
</template>

<script>

import { defineComponent } from 'vue'
import ViewerPic from './TheViewerPic'
import ViewerVideo from './TheViewerVideo.vue'
import callClientMixin from './helper/mixins/call-client-mixins'
import { MAC_PAN_URL } from './helper/utils/constants'
import { isVideoFile, isImageFile } from '@remote/utils/file-helper'
import { store } from '@remote/store'

export default defineComponent({
  components: {
    ViewerPic,
    ViewerVideo,
  },
  mixins: [callClientMixin],
  props: {
    previewFileInfo: {
      require: true,
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    return { store, ...props}
  },
  data: () => ({
    isLoading: true,
    showNoSupport: false,
    isShowImgComp: false,
    isShowVideoComp: false,
    isShowIframe: false,
    isBt: false,
    iframeSrc: '',
  }),
  computed: {
    fileId () {
      return this.previewFileInfo?.fileId || this.previewFileInfo?.id || this.previewFileInfo?.md5sum || ''
    },
    fileExtension () {
      return this.previewFileInfo?.fileExtension || this.previewFileInfo.file_extension || ''
    },
    mineType () {
      return this.previewFileInfo.mime_type || this.previewFileInfo.file_extension || ''
    },
    resource () {
      return this.previewFileInfo || {}
    },
    apps () {
      return (this.resource.apps || []).filter(v => v.link)
    },
    tipDesc () {
      if (this.isShare) return '请转存后在云盘文件中查看'
      return this.isMacThunder ? '该文件暂不支持预览，请取回后查看' : '该文件暂不支持预览，请用迅雷客户端查看'
    },
    tipOkText () {
      if (this.isShare) return '转存'
      return this.isMacThunder ? '确定' : '打开客户端'
    },
  },
  watch: {
    apps (list) {
      if (list && list.length > 0) {
        this.loadIframe(list[0].link)
      } else {
        if (this.isBt && !this.isShare) {
          // fetchBtfileToBencode(this.resource.web_content_link)
          //   .then(data => this.$emit('add', data))
          this.isLoading = false
          return
        }
        if (!this.isShowVideoComp && !this.isShowImgComp) {
          this.showNoSupport = true
          if (this.isShare) {
            this.$stat('pc_yunpan_share', 'share_page_non_support_pop_show')
          }
        }
      }
    },
  },
  async mounted () {
    if (isImageFile(this.fileExtension)) {
      this.isShowImgComp = true
      this.isLoading = false
      return
    }

    if (isVideoFile(this.fileExtension)) {
      this.isShowVideoComp = true
      this.isLoading = false
      return
    }
    if (this.fileExtension.includes('.torrent')) {
      this.isBt = true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onFail () {
      this.isShowIframe = false
      this.showNoSupport = true
    },
    loadIframe (appLink) {
      this.isLoading = false
      if (['.url', '.webloc'].includes(this.resource.file_extension)) {
        if (this.isMacThunder) {
          this.$native.sendMessage({ platform: 'mac', name: 'openURL', params: { url: appLink } })
        } else {
          window.open(appLink, '_blank')
        }
        this.close()
        return
      }
      this.iframeSrc = appLink
      this.isShowIframe = true
    },
    handleTipOk () {
      if (this.isShare && this.showNoSupport) {
        this.showNoSupport = false
        this.close()
        this.$stat('pc_yunpan_share', 'share_page_non_support_pop_click', { click_id: 'transfer-save', if_xunlei: this.isMacThunder || this.$native.isPC ? 1 : 0 })
        this.$emit('restore', this.fileId)
        return
      }
      if (this.isMacThunder || this.$native.isPC) {
        this.showNoSupport = false
        this.close()
        this.$emit('download', { position: 'preview', info: this.resource })
        return
      }
      if (this.isMac) {
        const url = `https://pan.xunlei.com?search=${JSON.stringify({ id: this.resource.parent_id, name: this.resource.name, fileId: this.fileId, open: 1 })}`
        const redirect = `${MAC_PAN_URL}&userId=${this.store.user?.userId}&jumpUrl=${encodeURIComponent(url)}`
        this.$native.evokeByTagA(redirect)
      }
      this.callThunderx({ opt: 'pan:location', params: { id: this.resource.parent_id, fileId: this.fileId, userid: this.curUser.userId, needSync: true } })
    },
  },
})
</script>
<style lang="scss">
.is-in-pc .file-processor {
  .dialog-viewer-picture > header {
    padding-top: 30PX;
  }
  .dialog-viewer-picture > header::after {
  content: "远程设备";
  color: black;
  width: 100%;
  display: flex;
  font-size: 14px;
  height: 30PX;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background-color: white;
}
}
</style>